import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import { createBrowserHistory } from 'history'
import { useEffect, useState } from 'react'
import AOS from 'aos'
import Routes from './Routes'

const browserHistory = createBrowserHistory()

browserHistory.listen((location) => {
  // Use setTimeout to make sure this runs after React Router's own listener
  setTimeout(() => {
    // Keep default behavior of restoring scroll position when user:
    // - clicked back button
    // - clicked on a link that programmatically calls `history.goBack()`
    // - manually changed the URL in the address bar (here we might want
    // to scroll to top, but we can't differentiate it from the others)
    if (location.pathname === 'POP') {
      return
    }
    // In all other cases, scroll to top
    window.scrollTo(0, 0)
  })
})

const App = () => {
  const [deviceToken, setDeviceToken] = useState('')

  useEffect(() => {
    // token(messaging, { vapidKey: 'BAYPLxmpc8f0_rOX_Egdbf3g24S28jS9E2YI-hwoNeJodjhQv03rljXqUjH2rGYXXv4ZT6m9SZjzDrdwkbcfsXw' }).then((currentToken) => {
    //   if (currentToken) {
    //     console.log(currentToken);
    //     setDeviceToken(currentToken);
    //   } else {
    //     console.log('No registration token available. Request permission to generate one.');
    //   }
    // }).catch((err) => {
    //
    // });
  }, [])

  AOS.init({
    once: true,
    delay: 50,
    duration: 500,
    easing: 'ease-in-out',
  })
  return (
    <BrowserRouter>
      <div className="App">
        <Routes deviceToken={deviceToken} />
      </div>
    </BrowserRouter>
  )
}

export default App
